import React, { Component } from 'react';

import { RequireAuth } from '@defi/core-ui';
import LoginContainer from './containers/LoginContainer';
import LoginContainerNew from './components/pages/LoginContainer';
import LoginContainerV3 from './v3components/pages/LoginContainer';
import ForgotContainer from './components/forgotpw/ForgotContainer';
import Logout from './components/pages/Logout';
import SsoLogout from './components/pages/SsoLogout';
import NotFound from './components/pages/NotFound';
import NotFoundV3 from './v3components/pages/NotFound';
import { CAN_RESET_USER_PASSSWORD } from './constants/canPermissions';
import { PASSWORD_EXPIRED } from './constants/profileConditions';
import {
  // PATH_LOGIN_FULL,
  // PATH_LOGOUT_FULL,
  // PATH_EXPIRED_FULL,
  // PATH_CHANGE_PASSWORD_FULL,
  PATH_RESET_PASSWORD_FULL,
  // PATH_FORGOT_PASSWORD_FULL,
} from './paths';


const getEnableV3Ui = () => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return false;
    const raw = window.localStorage.getItem('EnableV3Ui');
    if (raw === null) return false;
    if (raw === 'true' || raw === '1') return true;
    if (raw === 'false' || raw === '0') return false;
    try { return JSON.parse(raw) === true; } catch (e) { return false; }
  } catch (e) {
    return false;
  }
};

const enableV3Ui = getEnableV3Ui();

// Require permissions to edit page
const requireEditAbility = false;
const ignorePermissionsCheck = true;

class LoginWrapper extends Component {
  render() {

    return <LoginContainer {...this.props} />;
  }
}

// Setup Routes
export const getRoutes = [
  {
    path: "/ui/login/",
    content: enableV3Ui ? LoginContainerV3 : LoginContainerNew,
  },
  {
    path: "/ui/login/defilogin/",
    content: enableV3Ui ? LoginContainerV3 : LoginContainerNew,
  },
  {
    path: "/ui/login/logout/",
    content: Logout,
  },
  {
    path: "/ui/login/ssologout/",
    content: SsoLogout,
  },
  {
    path: '/ui/login/forgot-password/',
    content: ForgotContainer,
  },
  {
    path: '/ui/login/expired/',
    form: 'expired',
    content: RequireAuth(LoginWrapper, requireEditAbility, ignorePermissionsCheck, {
      Profile: PASSWORD_EXPIRED,
    }),
  },
  {
    path: '/ui/login/change-password/',
    form: 'change-password',
    content: RequireAuth(LoginWrapper, requireEditAbility, ignorePermissionsCheck),
  },
  {
    path: PATH_RESET_PASSWORD_FULL,
    form: 'reset-password',
    content: RequireAuth(LoginWrapper, requireEditAbility, ignorePermissionsCheck, {
      Can: CAN_RESET_USER_PASSSWORD,
    }),
  },
  {
    path: '',
    content: enableV3Ui ? NotFoundV3 : NotFound,
  },
];